import React, {useState} from 'react';
import COLORS from "../../Helpers/utils";

interface CustomButtonProps {
    title: string;
    metadata: string[];
    onClick: () => void;
    imagePath?: string;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    isHovered?: boolean;
    style?: React.CSSProperties;
    disabled?: boolean;
}

const BuildingCustomButton: React.FC<CustomButtonProps> = ({
                                                               title,
                                                               metadata,
                                                               onClick,
                                                               imagePath,
                                                               onMouseEnter,
                                                               onMouseLeave,
                                                               isHovered,
                                                               style,
                                                               disabled = false
                                                           }) => {
    const [hoverState, setHoverState] = useState(isHovered)

    return (
        <button
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                maxWidth: '400px',
                padding: '10px',
                borderRadius: '10px',
                border: 'none',
                backgroundColor: (isHovered || hoverState) ? '#ffffff' : COLORS.lightGrey,
                textAlign: 'left',
                cursor: disabled ? 'default' : 'pointer',
                transition: 'background-color 0.2s, opacity 0.2s',
                marginBottom: '15px',
                boxShadow: (isHovered || hoverState) ? '0 0 10px rgba(0, 0, 0, 0.2)' : 'none',
                opacity: disabled ? 0.6 : 1,
                ...style
            }}
            onMouseOver={(e) => (!disabled && setHoverState(true))}
            onMouseOut={(e) => (setHoverState(false))}
            onClick={disabled ? undefined : onClick}
            disabled={disabled}
        >
            {imagePath && (
                <img
                    src={`/Images/${imagePath}`}
                    alt={title}
                    style={{
                        width: '40px',
                        height: '40px',
                        objectFit: 'cover',
                        borderRadius: '5px',
                        margin: '5px',
                        opacity: disabled ? 0.5 : 1,
                    }}
                />
            )}
            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '10px' }}>
                <strong style={{
                    fontSize: '14px',
                    marginBottom: '5px',
                    color: disabled ? '#999' : 'inherit'
                }}>
                    {title}
                </strong>
                <span style={{
                    fontSize: '12px',
                    color: disabled ? '#999' : '#777'
                }}>
                    {Object.values(metadata).map((text, index) => (
                        <React.Fragment key={index}>
                            {text}<br/>
                        </React.Fragment>
                    ))}
                </span>
            </div>
        </button>
    );
};

export default BuildingCustomButton;